import { AccessoryAttributes, AccessoryType } from '@/types'
import { CreateAccessoryMutation } from './__generated__/create_mutation'
import { Mutation as CreateMutation } from './create_mutation'
import { useForm } from '@/helpers/useForm'
import { useEffect } from 'react'
import { Query as TableQuery } from './table_query'
import { Selector as ItemSelector } from './selector'
import { ErrorMessage, Field, Label } from '../base/fieldset'

interface Props {
  onSuccess: () => void
  defaultValues: Partial<AccessoryAttributes>
}

export const Form = ({ defaultValues, onSuccess }: Props) => {
  const {
    attributes,
    setAttributes,
    fieldErrors,
    save,
    saveSuccess,
    formBuilder,
    mutationLoading,
  } = useForm<CreateAccessoryMutation, AccessoryAttributes, never, never>({
    defaultValues: {
      accessoryId: '',
      assetTypeId: '',
      quantity: 0,
      accessoryType: AccessoryType.AssetType,
      optional: false,
      ...defaultValues
    },
    mutation: CreateMutation,
    resultKey: 'createAccessory',
    refetchQueries: [TableQuery]
  })

  useEffect(() => { if (saveSuccess) onSuccess() }, [saveSuccess, onSuccess])

  return (
    <div className="flex flex-col gap-6">
      { formBuilder.buildQueryError() }
      <Field>
        <Label>Item</Label>
        <ItemSelector
          invalid={!!fieldErrors?.accessoryId}
          value={`${attributes.accessoryType}:${attributes.accessoryId}`}
          onChange={value => {
            setAttributes({
              ...attributes,
              accessoryId: value?.id?.split(':')[1] || '',
              accessoryType: (value?.id?.split(':')[0] || '') as AccessoryType
            })
          }}
        />
        { fieldErrors?.accessoryId && <ErrorMessage>{ fieldErrors?.accessoryType }</ErrorMessage> }
      </Field>
      { formBuilder.buildField({ name: 'Quantity', field: 'quantity', type: 'integer' }) }
      { formBuilder.buildField({ name: 'Optional', field: 'optional', type: 'switch' }) }

      { formBuilder.saveButton(save, mutationLoading, saveSuccess) }
    </div>
  )
}
